import * as React from 'react';
import { PasswordsFieldFormRow } from '../Relations/FormsControls';
import { LoginFieldFormRow } from '../Relations/LoginFieldFormRow';
import { OptionType } from '../ResourcesAutocompleteMI';
import { IConfig, IFieldsConfig } from './IModels';
import lang from '../Relations/RelationsLang';

export type IMultipleEmployeeEditorValue = {
	[employeeId: number]: IMultipleEmployeeEditorValueData
}

export type IMultipleEmployeeEditorValueData = {
	passwordError: string;
	loginError: string;

	login: string;
	password: string;
	rePassword: string;
}

export function isValid(fieldsConfig: IFieldsConfig, value: IMultipleEmployeeEditorValue): boolean {
	let result = true;

	for (let v in value)
	{
		const employeData = value[v];
		employeData.loginError = "";
		employeData.passwordError = "";

		if (fieldsConfig.login.required) {
			if (!employeData.login) {
				let label = lang.getDefaultByPrefix(fieldsConfig.login, "label", "login");
				employeData.loginError = lang.fieldIsRequiredError(label);
				result = false;
			}
		}

		if (fieldsConfig.password.required) {
			if (!employeData.password) {
				let label = lang.getDefaultByPrefix(fieldsConfig.password, "label", "password");
				employeData.passwordError = lang.fieldIsRequiredError(label);
				result = false;
			}
		}
		if (employeData.password) {
			if (employeData.password != employeData.rePassword) {
				employeData.passwordError = lang.retypePasswordError();
				result = false;
			}
		}
	}

	return result;
}

interface IMultipleEmployeeEditor {
	resourceId: number,
	resourceKind: "Application" | "ServiceAsset",
	selectedEmployees: OptionType[],

	config: IConfig,

	value: IMultipleEmployeeEditorValue;
	onChange: (v: IMultipleEmployeeEditorValue) => void;
	onChangedReferenceNumber: (args: string) => void;
	onChangedLocation: (args: string) => void;
}

export function MultipleEmployeeEditor(props: IMultipleEmployeeEditor) {

	let fields = props.config.fields;
	const value = props.value ?? {};

	function onChangedLogin(key: number, login: string) {
		const v = { ...value };
		if (!v[key]) {
			v[key] = {
				login: "",
				loginError: "",
				password: "",
				passwordError: "",
				rePassword: "",
			}
		}
		v[key].login = login;
		v[key].loginError = "";
		props.onChange(v);
	}

	function onChangedPassword(key: number, password1: string, password2: string) {
		const v = { ...value };
		if (!v[key]) {
			v[key] = {
				login: "",
				loginError: "",
				password: "",
				passwordError: "",
				rePassword: "",
			}
		}
		v[key].password = password1;
		v[key].rePassword = password2;
		v[key].passwordError = "";
		props.onChange(v);
	}

	let selectedEmployees = props.selectedEmployees ?? [];
	if (!props.selectedEmployees || props.selectedEmployees.length === 0) {
		selectedEmployees = [{ value: "0", kind: "Employee", label: "", description: "" }];
	}

	return <>
		{selectedEmployees.map(selectedEmployee => {
			let key = 0;
			if (selectedEmployee) {
				key = parseInt(selectedEmployee.value, 10);
			}
			

			const data: IMultipleEmployeeEditorValueData = value[key] ?? {
				login: "",
				loginError: "",
				password: "",
				passwordError: "",
				rePassword: "",
			};

			return <div key={key}>
				<LoginFieldFormRow
					name="login"
					errorText={data.loginError}
					config={fields.login}
					value={data.login}
					onChange={(value) => onChangedLogin(key, value)}

					applicationId={props.resourceId}
					employeeId={key}
					onChangedLocation={props.onChangedLocation}
					onChangedReferenceNumber={props.onChangedReferenceNumber}
				/>

				<PasswordsFieldFormRow
					name="password"
					errorText={data.passwordError}
					config={fields.password}
					value1={data.password}
					value2={data.rePassword}
					onChange={(password1, password2) => onChangedPassword(key, password1, password2)}
				/>
			</div>
		})}

	</>
}